import React from 'react';
import CrearEgresos from '../../../components/insumos/egresos/CrearEgresos';

const CrearEgresosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <CrearEgresos />
    </div>
  );
};

export default CrearEgresosPage;